import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class CarrierService {
    constructor(private datatask: DataTaskService) {}

    public getCarriersKeyNames(params?: GetCarriersKeyNamesParams): Promise<CarrierKeyNameItem[]> {
        return this.datatask.Post(4023, params);
    }
}

export interface CarrierKeyNameItem {
    carrier_keyno: string;
    carrier_name: string;
    carrier_keyname: string;
}

export interface GetCarriersKeyNamesParams {
    language_id?: string;
}
